import {
    Component,
    ErrorService
} from "../../../core/index";

import styles from "./error-message.scss";
import template from "./error-message.html";

@Component({
    selector: "becErrorMessage",
    template,
    bindings: {
		messageStyle: "@",
		disableClose: "<"
    }
})
export class ErrorMessage {
    static $inject = ["ErrorService"];
    constructor(private errorService: ErrorService) { }

    styles = styles;

	messageStyle: string;
	disableClose: boolean;

    get errorMessageVisible() {
        return this.errorService.errorMessageVisible;
    }

	hideError() {
		if (!this.disableClose)
			this.errorService.hideError();
    }

	get errorMessage() {
        return this.errorService.errorMessage;
    }

    get messageStyleOrDefault() {
        if (!this.messageStyle) {
            this.messageStyle = "default";
        }
        return styles[this.messageStyle];
    }
}
